import EditPicButton from "components/General-UI/EditPicButton";
import FileDownload from "graphics/icons/Board/FileDownload";
import ImageDownload from "graphics/icons/Board/ImageDownload";
import React, { useEffect, useState } from "react";
import {
  downloadBoardFile,
  downloadBoardImage,
  getBoardPreview,
} from "space/spaceBoard";

const BoardDownloadModal = ({ luid, onClose }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    getBoardPreview(luid).then(setPreview);
  }, [luid]);
  return (
    <div>
      <div>
        <img className="board-preview" src={preview} alt="whiteboard preview" />
      </div>
      <br />
      <div className="download-modal-content">
        <EditPicButton
          text="Flattened Image (PNG)"
          onClick={() => downloadBoardImage(luid).then(onClose)}
        >
          <ImageDownload />
        </EditPicButton>
        <EditPicButton
          text="Editable Whiteboard File"
          onClick={() => downloadBoardFile(luid).then(onClose)}
        >
          <FileDownload />
        </EditPicButton>
      </div>
    </div>
  );
};

export default BoardDownloadModal;
